define('casino/start',['jquery', 'casino/casino-data', 'casino/bundles', 'casino/love', 'casino/jackpots', 'casino/populate'], function($, casinoData, bundles, love, jackpots) {
	'use strict';

	var start = {
		initialized: false,
		init: function initializeStartPage() {
			if(this.initialized) {
				return;
			}
			this.initialized = true;

			$('#highlights').populate(casinoData.highlights, {gamesPerPage: 8}).scroller({direction: 'left', auto: false});

			var gameIds = Object.keys(casinoData.games);
			$('#casino-start').find('.cnt-filter h1').first().applyTemplate({count: gameIds.length});

			bundles.init();
			love.setupStartPage();
			jackpots.initStartPageSlider(casinoData.highJackpots);
		}
	};
	return start;
});

